module.exports = __webpack_public_path__ + "static/Half_Ogre-c633f642883619e5505590f80e34196a.jpg";